export const rsvpButtons = [
  {
    name: "Going",
    color: "#82DF96",
  },
  {
    name: "Maybe Going",
    color: "#C4C4C4",
  },
  {
    name: "Not Going",
    color: "#EA6565",
  },
];
